import { ICard } from "../types/card-type";
import { formatReportDate } from "../helpers/format-date";

import weatherIcon from "@/img/weather-report-icon.svg";
import warningIcon from "@/img/warning-icon.svg";
import phoneAppIcon from "@/img/phone-app-icon.svg";
import shareIcon from "@/img/share-icon.svg";
import climateIcon from "@/img/climate-icon.svg";

export const cardData: ICard[] = [
	{
		icon: weatherIcon,
		description: `Weather Report \n ${formatReportDate()}`,
		link: null,
		alt: "weather report-icon",
	},
	{
		icon: warningIcon,
		description: `Understanding our weather warnings`,
		link: "/warnings#section-alert",
		alt: "warning icon",
	},
	{
		icon: climateIcon,
		description: `Consult our climate portal here.`,
		link: null,
		alt: "Consult our climate portal here.",
	},
	{
		icon: phoneAppIcon,
		description: `Download our free Mobile App `,
		link: "/app-promotion",
		alt: "Download mobile app on app store icon",
	},
	{
		icon: shareIcon,
		description: `Share your opinions and suggestions regarding our weather services`,
		link: null,
		alt: "Share your opinion icon",
	},
];
